import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { convertImageFromDto } from "@modules/dtos/imageDto"
import { UserProgramItemEntity } from "@modules/programs/entities/userProgramItemEntity"
import { type LightProgramInfoDto } from "@modules/programs/gateway/programDto"
import { ProgramType } from "@modules/programs/types/programTypes"
import { type HUImage } from "@modules/types/imageTypes"

export class LightProgramInfoEntity {
  id: string
  name: string
  image: HUImage | null
  price: PriceObjectEntity | null
  type: ProgramType

  private constructor(lightProgramInfo: LightProgramInfoEntity) {
    this.id = lightProgramInfo.id
    this.name = lightProgramInfo.name
    this.image = lightProgramInfo.image
    this.price = lightProgramInfo.price
    this.type = lightProgramInfo.type
  }

  static fromDto(dto: LightProgramInfoDto): LightProgramInfoEntity {
    return new LightProgramInfoEntity({
      id: dto.id,
      name: dto.name,
      image: dto.image ? convertImageFromDto(dto.image) : null,
      price: dto.price ? PriceObjectEntity.fromDto(dto.price) : null,
      type: dto.type,
    })
  }

  static fromUserProgramItem(item: UserProgramItemEntity): LightProgramInfoEntity {
    return new LightProgramInfoEntity({
      id: item.id,
      name: item.name,
      image: item.image,
      price: item.price ? PriceObjectEntity.fromDto(item.price) : null,
      type: item.type,
    })
  }
}
